/**
 * Filters out amenities whose expiry_date is today or in the past.
 * Moved from src/app/admin/services/property-specifications-table.service.ts
 * (L2-P0.5) — a pure utility used by records + efficiencies, not an admin concern.
 * @param amenities Array of amenity objects
 * @returns Filtered array of amenities that expire in the future
 */
export function filterAmenitiesNotExpiredToday(amenities: any[]): any[] {
  const today = new Date().toISOString().slice(0, 10);
  return Array.isArray(amenities)
    ? amenities.filter(amenity => !amenity?.expiry_date || amenity?.expiry_date.slice(0, 10) > today)
    : [];
}
